import React from "react";
import { View } from "react-native";
import type { Clinic } from "@louise/clinics/clinics.types";
import ClinicLocationCardBase, {
  OpenMapsPill,
  type ClinicLocationMapPreviewProps,
} from "./ClinicLocationCardBase";

const WebMapFrame = "iframe" as unknown as React.ComponentType<{
  src: string;
  title: string;
  loading: "lazy";
  referrerPolicy: string;
  style: React.CSSProperties;
}>;

function WebMapPreview({
  addressQuery,
  addressLabel,
  onPress,
  openMapsLabel,
}: ClinicLocationMapPreviewProps) {
  const mapSrc = `https://www.google.com/maps?q=${encodeURIComponent(addressQuery)}&output=embed`;

  return (
    <View
      style={{
        height: 150,
        width: "100%",
        borderRadius: 12,
        overflow: "hidden",
        backgroundColor: "rgba(200,180,160,0.15)",
        marginBottom: 16,
      }}
    >
      <WebMapFrame
        src={mapSrc}
        title={`${addressLabel} map`}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        style={{
          width: "100%",
          height: "100%",
          border: 0,
          display: "block",
        }}
      />
      <OpenMapsPill onPress={onPress} label={openMapsLabel} />
    </View>
  );
}

export default function ClinicLocationCard({ clinic }: { clinic: Clinic }) {
  return <ClinicLocationCardBase clinic={clinic} MapPreview={WebMapPreview} />;
}
